module.exports = __webpack_public_path__ + "img/default_avatar@2x.edba3f70.png";